import {of as observableOf,  Observable } from 'rxjs';
import {catchError, switchMap, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import * as Action from '../store/actions';
import { SitesService } from '../sites.service';

@Injectable()
export class Effects {

    /* Retrieve all sites */

    @Effect()
    requestSites: Observable<Action.RequestSitesFailure | Action.RequestSitesSuccess> = this.actions$.pipe(
      ofType(Action.REQUEST_SITES),
      switchMap((action: Action.RequestSites) => {
        return this.sitesService.getSites().pipe(map((sites) => {
          return new Action.RequestSitesSuccess(sites);
        }),
        catchError(e => {
          return observableOf(new Action.RequestSitesFailure(e));
        }),);
      }));

    /* Find a site */

    @Effect()
    findSite: Observable<Action.FindSiteFailure | Action.FindSiteSuccess> = this.actions$.pipe(
        ofType(Action.FIND_SITE),
        switchMap((action: Action.FindSite) => {
          return this.sitesService.getSite(action.payload).pipe(map((site) => {
            return new Action.FindSiteSuccess(site);
          }),
          catchError(e => {
            return observableOf(new Action.FindSiteFailure(e));
          }),);
        }));

    /* Find all devices of a site */

    @Effect()
    findDevicesOfSite: Observable<Action.FindDevicesOfSiteFailure | Action.FindDevicesOfSiteSuccess> = this.actions$.pipe(
      ofType(Action.FIND_SITE_DEVICES),
      switchMap((action: Action.FindDevicesOfSite) => {
        return this.sitesService.getDevicesFromSite(action.payload).pipe(map((site) => {
            return new Action.FindDevicesOfSiteSuccess(site);
          }),
          catchError(e => {
            return observableOf(new Action.FindDevicesOfSiteFailure(e));
          }),);
      }));

    /* Add site */

    @Effect()
    addSite: Observable<Action.AddSiteFailure | Action.AddSiteSuccess> = this.actions$.pipe(
      ofType(Action.ADD_SITE),
      switchMap((action: Action.AddSite) => {
        return this.sitesService.addSite(action.payload).pipe(map((sites) => {
          return new Action.AddSiteSuccess(sites);
        }),
        catchError(e => {
          return observableOf(new Action.AddSiteFailure(e));
        }),);
      }));

    /* Edit site */

    @Effect()
    editSite: Observable<Action.EditSiteFailure | Action.EditSiteSuccess> = this.actions$.pipe(
      ofType(Action.EDIT_SITE),
      switchMap((action: Action.EditSite) => {
        return this.sitesService.editSite(action.id, action.payload).pipe(map((sites) => {
          return new Action.EditSiteSuccess(action.id, sites);
        }),
        catchError(e => {
          return observableOf(new Action.EditSiteFailure(e));
        }),);
      }));

    /* Delete site */

    @Effect()
    deleteSite: Observable<Action.DeleteSiteFailure | Action.DeleteSiteSuccess> = this.actions$.pipe(
      ofType(Action.DELETE_SITE),
      switchMap((action: Action.DeleteSite) => {
        return this.sitesService.deleteSite(action.id).pipe(map((sites) => {
          return new Action.DeleteSiteSuccess(sites);
        }),
        catchError(e => {
          return observableOf(new Action.DeleteSiteFailure(e));
        }),);
      }));

    /* Assign devices to site */

    @Effect()
    assignDevices: Observable<Action.AssignDevicesFailure | Action.AssignDevicesSuccess> = this.actions$.pipe(
      ofType(Action.ASSIGN_DEVICES),
      switchMap((action: Action.AssignDevices) => {
        return this.sitesService.assignDevices(action.id, action.payload).pipe(map((sites) => {
          return new Action.AssignDevicesSuccess(sites);
        }),
        catchError(e => {
          return observableOf(new Action.AssignDevicesFailure(e));
        }),);
      }));

    constructor(private sitesService: SitesService,
                private actions$: Actions,) {}
}
